import { useState } from "react";
import Axios from "axios";
import { adalApiFetch } from "config/azureConfig";

export const useDownload = () => {
    const [error, setError] = useState(null);

    const download = async (
        url,
        filename
    ) => {
        setError(null);
        try {
            const response = await new Promise((resolve, reject) => {
                try {
                    const res = adalApiFetch(
                        Axios,
                        url,
                        {
                            method: "get",
                            responseType: "blob"
                        }
                    );
                    resolve(res);
                } catch (err) {
                    reject(err);
                }
            });
            const blob = response instanceof Blob ? response : response.data;
            const downloadUrl = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = downloadUrl;
            link.download = filename ?? "download";
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(downloadUrl);
        } catch (err) {
            console.error("Download failed:", err);
            setError(err);
            throw err;
        }
    };
    return {
        download,
        error
    };
};